import React, {useEffect, useState} from "react";
import {getDashboardUsers} from "services/Users.service";
import Select from "react-select";

export const FilterSelectUsers = ({handleChangeUser}) => {

    const [listUsers, setListUsers] = useState([])

    useEffect(() => {
        (async () => {

            const usersLeader = await getDashboardUsers(false, 1,  2)
            const usersRespondents = await getDashboardUsers(false,1, 3)

            Promise.all([usersLeader, usersRespondents]).then(function([leaders, respondents]) {

                const listLeaders = leaders.map((leader) => { return {
                    id: leader.id, username: leader.username, profile: leader.profile
                }})

                const listRespondents = respondents.map((respondent) => { return {
                    id: respondent.id, username: respondent.username, profile: respondent.profile
                }})

                createList([...listLeaders, ...listRespondents])
            });

        })();
    },[])

    const createList = (response = []) => {
        const newUsersList = response.map((user) => {

            const profileLabel = user.profile === 3 ? 'Respondente' : 'Líder ESG'

            return {value: user.id, label: user.username + ' - ' + profileLabel};
        })
        setListUsers(newUsersList);
    }

    const changeSelect = (newValue, {action}) => {
        switch (action) {
            case 'select-option':
                handleChangeUser(newValue.value)
                break
            case 'clear':
                handleChangeUser('')
                break
            default:
                return
        }
    };


    return (
        <>
            <Select
                onChange={changeSelect}
                options={listUsers}
                isClearable={true}
                placeholder="Selecione ou busque o usuário"
                noOptionsMessage={() => "Nenhum usuário encontrado"}
            />

        </>
    )
}